import { FC, ReactNode } from 'react';
import { motion } from 'framer-motion';

import './TeamBlankStage.scss';
import { teamCardVariants } from '../constants';

interface TeamBlankStageProps {
  children: ReactNode;
  stageKey: string;
  isLoading?: boolean;
}

const renderBlob = (className: string) => <span aria-hidden="true" className={className} />;

const TeamBlankStage: FC<TeamBlankStageProps> = ({ children, stageKey, isLoading = false }) => {
  return (
    <motion.section
      key={stageKey}
      className={`team-blank-stage${isLoading ? ' team-blank-stage--loading' : ''}`}
      variants={teamCardVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      aria-busy={isLoading || undefined}
    >
      {renderBlob('team-blob team-blob--top-left')}
      {renderBlob('team-blob team-blob--bottom-right')}
      {children}
    </motion.section>
  );
};

export default TeamBlankStage;
